import * as fromPreorderSupplierActions from '../../actions/preorder/supplier.actions';
import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {Observable} from 'rxjs';
import {PreorderRestService} from '../../../services/api/preorder.rest-service';

@Injectable()
export class PreorderSupplierEffects {
    private actions$ = inject(Actions);
    private preorderRestService = inject(PreorderRestService);


    loadSuppliers$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType<fromPreorderSupplierActions.InitLoadAllSuppliers>(fromPreorderSupplierActions.SupplierActionTypes.INIT_LOAD_ALL_SUPPLIERS))
            .pipe(switchMap(() =>
                    this.preorderRestService.loadAllSuppliers().pipe(
                        map(data => new fromPreorderSupplierActions.LoadAllSuppliersComplete(data.returnObject)),
                        catchError((error) => of(new fromPreorderSupplierActions.LoadAllSuppliersFailed(error)))
                    )
                )
            )
    );
}
